// Limited Time Promotions take first priority, except when an item is on Sale/Clearance.
const badgeValues = [
  {
    type: 'evergreen',
    tag: ['coming soon', 'badge coming soon'],
    text: 'Coming Soon',
  },
  {
    type: 'badge',
    tag: ['clearance', 'badge clearance'],
    text: 'Clearance',
  },
  {
    type: 'badge',
    tag: ['on sale', 'badge on sale'],
    text: 'Sale',
  },
  {
    type: 'promo',
    tag: ['20 off', 'badge 20off'],
    text: '20% Off',
  },
  {
    type: 'promo',
    tag: ['25 off', 'badge 25off'],
    text: '25% Off',
  },
  {
    type: 'promo',
    tag: ['30 off', 'badge 30off'],
    text: '30% Off',
  },
  {
    type: 'promo',
    tag: ['40 off', 'badge 40off'],
    text: '40% Off',
  },
  {
    type: 'promo',
    tag: ['50 off', 'badge 50off'],
    text: '50% Off',
  },
  {
    type: 'promo',
    tag: ['60 off', 'badge 60off'],
    text: '60% Off',
  },
  {
    type: 'promo2',
    tag: ['2 for 30', 'badge 2for30'],
    text: '2 for $30',
  },
  {
    type: 'promo2',
    tag: ['bogo 50 off', 'badge bogo50'],
    text: 'BOGO 50% Off',
  },
  {
    type: 'promo2',
    tag: ['bogo 60 off', 'badge bogo60'],
    text: 'BOGO 60% Off',
  },
  {
    type: 'promo2',
    tag: ['bogo free', 'badge bogofree'],
    text: 'BOGO Free',
  },
  {
    type: 'promo2',
    tag: ['b1g1 free', 'badge b1g1free'],
    text: 'B1G1 Free',
  },
  {
    type: 'promo2',
    tag: ['b2g1 free', 'badge b2g1free'],
    text: 'B2G1 Free',
  },
  {
    type: 'promo2',
    tag: ['buy more save more', 'badge buy more save more'],
    text: 'Buy More Save More',
  },
  {
    type: 'promo2',
    tag: ['special price', 'badge special price'],
    text: 'Special Price',
  },
  {
    type: 'promo2',
    tag: ['ships free', 'badge ships free'],
    text: 'Ships Free',
  },
  {
    type: 'promo2',
    tag: ['gift with purchase', 'badge gwp'],
    text: 'Gift With Purchase',
  },
  {
    type: 'promo2',
    tag: ['flash sale', 'badge flash sale'],
    text: 'Flash Sale',
  },
  {
    type: 'halloween',
    tag: ['halloween', 'badge halloween'],
    text: '<img src="https://cdn.shopify.com/s/files/1/0070/8853/7651/files/Badge_Halloween.gif?v=1754071207" alt="Halloween Badge" class="ProductBadge--halloween-image" />',
  },
  {
    type: 'evergreen',
    tag: ['part of a set', 'badge part of a set'],
    text: 'Part of a Set',
  },

  {
    type: 'evergreen',
    tag: ['selling fast', 'badge selling fast'],
    text: 'Selling Fast',
  },
  {
    type: 'evergreen',
    tag: ['low in stock', 'badge low in stock'],
    text: 'Low In Stock',
  },
  {
    type: 'evergreen',
    tag: ['almost gone', 'badge almost gone'],
    text: 'Almost Gone',
  },
  {
    type: 'evergreen',
    tag: ['back in stock', 'badge back in stock'],
    text: 'Back In Stock',
  },
  {
    type: 'evergreen',
    tag: ['fan favorite', 'badge fan favorite'],
    text: 'Fan Favorite',
  },
  {
    type: 'evergreen',
    tag: ['matching separate', 'badge matching separate'],
    text: 'Matching Separate',
  },
  {
    type: 'evergreen',
    tag: ['2 piece set', 'badge 2piece'],
    text: '2 Piece Set',
  },
  {
    type: 'evergreen',
    tag: ['limited quantities', 'badge limited quantities'],
    text: 'Limited Quantities',
  },
  {
    type: 'evergreen',
    tag: ['trending', 'badge trending'],
    text: 'Trending',
  },
  {
    type: 'evergreen',
    tag: ['specialty gown', 'badge specialty gown'],
    text: 'Specialty Gown',
  },
  {
    type: 'evergreen',
    tag: ['ships free 75', 'badge ships free75'],
    text: 'Ships Free (for 75+)',
  },
  {
    type: 'evergreen',
    tag: ['top rated', 'badge top rated'],
    text: 'Top Rated',
  },
  {
    type: 'evergreen',
    tag: ['badge final sale'],
    text: 'Final Sale',
  },
  {
    type: 'evergreen',
    tag: ['free express shipping', 'badge free express shipping'],
    text: 'Free Express Shipping',
  },
  {
    type: 'badge',
    tag: ['glow in the dark', 'badge glow in the dark'],
    text: 'glow in the dark',
  },
  {
    type: 'badge',
    tag: ['new arrival', 'badge new arrival'],
    text: 'New Arrival',
  },
  {
    type: 'badge',
    tag: ['new color', 'badge new color'],
    text: 'New Color',
  },
  {
    type: 'badge',
    tag: ['plus available', 'badge plus available'],
    text: 'Plus Available',
  },
  {
    type: 'badge',
    tag: ['pre-order', 'badge pre-order'],
    text: 'Pre-Order',
  },
  {
    type: 'badge',
    tag: ['web exclusive', 'badge web exclusive'],
    text: 'Web Exclusive',
  },
  {
    type: 'badge',
    tag: ['best seller', 'badge best seller'],
    text: 'Best Seller',
  },
  {
    type: 'badge',
    tag: ['top rated', 'badge limited edition'],
    text: 'Limited Edition',
  },
  {
    type: 'badge',
    tag: ['stylist picks', 'badge stylist picks'],
    text: 'Stylist Picks',
  },
  {
    type: 'badge',
    tag: ['featured item', 'badge featured item'],
    text: 'Featured Item',
  },
  {
    type: 'badge',
    tag: ['web only', 'badge web only'],
    text: 'Web Only',
  },
  {
    type: 'badge',
    tag: ['web only exclusive', 'badge web only exclusive'],
    text: 'Web Only Exclusive',
  },
  {
    type: 'badge',
    tag: ['web only price', 'badge web only'],
    text: 'Web Only Price',
  },
  {
    type: 'badge',
    tag: ['online only', 'badge online only'],
    text: 'Online Only',
  },
  {
    type: 'badge',
    tag: ['online only price', 'badge online only price'],
    text: 'Online Only Price',
  },
];

export { badgeValues };

export default class ProductBadge {
  #badgeValues = badgeValues;

  constructor(tags, parentNode) {
    this.tags = tags;
    this.selectedBadge = [];
    this.parentNode = parentNode;

    this.init();
  }

  /**
   * Set up specific badges that matches with product tags
   */
  setSpecificBadge() {
    for (const badgeValue of this.#badgeValues) {
      if (badgeValue.tag.some((t) => this.tags.indexOf(t) >= 0)) {
        this.selectedBadge.push(badgeValue);
        break;
      }
    }
  }

  /**
   * Build the class names that will be employed by ProductTile badge instance
   * @param {Object} badge - badge object
   * @returns {String[]} - array of class names
   */
  setClasses(badge) {
    const classNames = ['ProductBadge'];

    if (badge.text === 'Sale' || badge.text === 'Clearance' || badge.type === 'limited_time') {
      classNames.push('ProductBadge--red');
    }
    if (badge.type === 'evergreen') {
      classNames.push('ProductBadge--white');
    }
    if (
      badge.type === 'promo' ||
      badge.type === 'promo2' ||
      badge.text === 'BOGO' ||
      badge.text.includes('% off') ||
      badge.text.includes('OFF') ||
      badge.text.includes('promo')
    ) {
      classNames.push('ProductBadge--purple');
    }
    if (badge.type === 'promo' && badge.text.length <= 6) {
      classNames.push('ProductBadge--purple-short');
    }

    return classNames;
  }

  /**
   * Initialize ProductTile badge
   */
  init() {
    this.setSpecificBadge();

    if (!this.selectedBadge.length) return;

    this.selectedBadge.forEach((badge) => {
      if (badge.type === 'halloween') {
        const badgeNode = document.createElement('img');
        badgeNode.src = 'https://cdn.shopify.com/s/files/1/0070/8853/7651/files/Badge_Halloween.gif?v=1754071207';
        badgeNode.alt = 'Halloween Badge';
        badgeNode.classList.add('ProductBadge--halloween-image', 'ProductBadge--halloween-fastsimon');
        this.parentNode.appendChild(badgeNode);
      } else {
        const badgeNode = document.createElement('div');
        badgeNode.innerText = badge.text;
        badgeNode.classList.add(...this.setClasses(badge));
        this.parentNode.appendChild(badgeNode);
      }
    });
  }
}
